import { Grid, xcss } from '@atlaskit/primitives';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import weekday from 'dayjs/plugin/weekday';
import React from 'react';

import { EntryCardProps } from './Calendar';
import DayCard from './DayCard';

dayjs.extend(isoWeek);
dayjs.extend(weekday);

interface CalendarProps {
  canEditContent: boolean;
  year: number;
  month: number;
  EntryCardValueComponent: React.ComponentType<EntryCardProps>;
}

const getWeeks = (startOfCalendar: dayjs.Dayjs, endOfCalendar: dayjs.Dayjs) => {
  const weeks: dayjs.Dayjs[][] = [];
  let current = startOfCalendar;

  while (current.isBefore(endOfCalendar)) {
    const week: dayjs.Dayjs[] = [];
    for (let i = 0; i < 7; i++) {
      week.push(current);
      current = current.add(1, 'day');
    }
    weeks.push(week);
  }

  return weeks;
};

const CalendarGrid: React.FC<CalendarProps> = ({
  canEditContent,
  year,
  month,
  EntryCardValueComponent,
}) => {
  const startOfMonth = dayjs().year(year).month(month).startOf('month');
  const endOfMonth = dayjs().year(year).month(month).endOf('month');
  const startOfCalendar = startOfMonth.startOf('week');
  const endOfCalendar = endOfMonth.endOf('week');

  const weeks: dayjs.Dayjs[][] = getWeeks(startOfCalendar, endOfCalendar);

  return (
    <Grid templateRows="auto auto auto auto auto">
      {weeks.map((week, weekIndex) => (
        <Grid
          key={weekIndex.toString()}
          templateColumns="repeat(7, minmax(0, 1fr))"
          xcss={xcss({
            minHeight: '200px',
          })}
        >
          {week.map((day, dayIndex) => (
            <DayCard
              canEditContent={canEditContent}
              isCurrentDay={day.isSame(dayjs(), 'day')}
              EntryCardValueComponent={EntryCardValueComponent}
              isFirstRow={weekIndex === 0}
              isFirstColumn={dayIndex === 0}
              isLastColumn={dayIndex === week.length - 1}
              key={day.toString()}
              day={day}
            />
          ))}
        </Grid>
      ))}
    </Grid>
  );
};

export default CalendarGrid;
